window.HistoricoFiltroItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-listar-historico-filtro-item",
    tagName: "tr",
    className: "clicavel",
    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
        this.controller = options.controller;
    },

    events: {
        'click td.areaClicavel': "selecionarHistorico",
        'click td.icone-pin': "fixarItem",
        'click td.icone-lista': "desafixarItem"
    },

    fixarItem: function() {
        this.controller.fixarItem(this.model);
        return;
    },

    desafixarItem: function() {
        this.controller.desafixarItem(this.model);
        return;
    },

    selecionarHistorico: function() {

        var json = $.parseJSON(this.model.attributes.Filtro);
        var $formulario = $("#form-pesquisar-produto");

        global.bindJSONToForm("#form-pesquisar-produto", json);

        var $filtros = $("#mais-filtros");

        if (!$filtros.is(":visible")) {
            $("#mostrar-mais-filtros").toggleClass("oculto");
            $filtros.slideDown(200);
        }

        $("#pesquisar-produtos").click();
        $("#breadcrumb-cancelar").click();
    }

});

window.HistoricoFiltroView = Backbone.Marionette.CompositeView.extend({
    template: "#template-listar-historico-filtro",
    childView: HistoricoFiltroItemView,
    childViewContainer: "#lista-historico-filtro-container",


    initialize: function(options) {
        this.app = options.app;
        this.controller = options.controller;
    },

    events: {
        'click #HistoricoFiltro_FiltrarCliente': "pesquisarHistoricoFiltro"
    },

    pesquisarHistoricoFiltro: function () {
        this.controller.pesquisarHistoricoFiltro(this.model);
        return;
    },

    buildChildView: function(item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this,
            controller: this.controller
        });
        return view; 
    }
});
